/* eslint-disable indent */
import { gql } from '@apollo/client';
import { loader } from 'graphql.macro';

const WORKSPACE_FIELDS_FRAGMENT = gql`
    fragment workspaceFields on workspace {
        id
        name
        archived
        created_at
        created_by
        owner_id
        group_id
        users {
            user_id
            user_type
        }
        pipelines {
            id
        }
        models {
            models {
                id
            }
        }
    }
`;

const USER_DEFAULT_WORKSPACE_FIELDS = gql`
    fragment userDefaultWorkspaceFields on user_default_workspace {
        id
        user_id
        workspace_id
        workspace {
            id
            name
            archived
            created_at
            created_by
            owner_id
            group_id
            users {
                user_id
                user_type
            }
        }
    }
`;

export const FETCH_WORKSPACES_QUERY = gql`
    ${WORKSPACE_FIELDS_FRAGMENT}
    
    query GetWorkspaces {
        workspace {
            id
            name
            created_by
            owner_id
            archived
            users {
                user_id
                user_type
            }
        }
    }
`

export const FETCH_WORKSPACE_BY_ID_QUERY = gql`
    query WorkspaceById($id: bigint!) {
        workspace_by_pk(id: $id) {
            archived
            created_at
            created_by
            owner_id
            id
            name
            users {
                user_id
                user_type
            }
            models {
                models {
                    id
                }
            }
            pipelines {
                id
            }
        }
    }
`

export const FETCH_DEFAULT_WORKSPACE = gql`
    ${USER_DEFAULT_WORKSPACE_FIELDS}
    
    query UserDefaultWorkspace($user_id: String = "") {
        user_default_workspace(where: {user_id: {_eq: $user_id}}) {
            workspace {
                archived
                created_at
                created_by
                owner_id
                name
                id
                users {
                    user_id
                    user_type
                }
                pipelines {
                    id
                }
                models {
                    models {
                        id
                    }
                }
            }
        }
    }
`

export const CREATE_WORKSPACE_QUERY = gql`
    mutation CreateWorkspace($user_id: String!, $workspace_name: String!, $user_type:String) {
        insert_workspace_one(object: {name: $workspace_name, users: {data: {user_id: $user_id, user_type: $user_type}}, archived: false}) {
            id
        }
    }
`

export const INSERT_WORKSPACE_USER_QUERY = gql`
    mutation InsertWorkspaceUser($user_id: String!, $user_type: String!, $workspace_id: bigint) {
        insert_workspace_users_one(object: {user_id: $user_id, user_type: $user_type, workspace_id: $workspace_id}, on_conflict: {constraint: workspace_users_workspace_id_user_id_key, update_columns: user_type}) {
            id
        }
    }
`

export const UPDATE_WORKSPACE_USER_QUERY = gql`
    mutation UpdateWorkspaceUserRole($user_id: String, $workspace_id: bigint, $user_type: String) {
        update_workspace_users(where: {user_id: {_eq: $user_id} _and: {workspace_id: { _eq: $workspace_id }} },
            _set:{user_type: $user_type }) {
            affected_rows
        }
    }
`

export const DELETE_WORKSPACE_USER_QUERY = gql`
    mutation DeleteWorkspaceUser($user_id: String!, $workspace_id: bigint!) {
        delete_workspace_users(where: {user_id: {_eq: $user_id}, _and: {workspace_id: {_eq: $workspace_id}}}) {
            affected_rows
        }
    }
`

export const GET_WORKSPACE_BY_NAME_QUERY = loader('../../api/graphql/WorkspaceByName.graphql');
export const GET_WORKSPACE_BY_ID_QUERY = loader('../../api/graphql/WorkspaceById.graphql');
export const CREATE_DEFAULT_WORKSPACE = loader('../../api/graphql/CreateDefaultUserWorkspace.graphql');

export const transformUserResponse = ({
    user_id: userId,
    user_type: userType
}) => ({ userId, userType })

export const transformWorkspaceResponse = ({
    archived,
    id,
    name,
    users,
    models,
    pipelines,
    created_at: createdAt,
    // created_by: createdBy,
    owner_id,
}) => ({
    id,
    name,
    archived,
    createdAt,
    createdBy: owner_id,
    workspaceId: id,
    users: users?.length ? users?.map(transformUserResponse) : [],
    models: models?.length ? models?.flatMap(({ models: innerModels }) => innerModels?.map(({ id: modelId }) => modelId)) : [],
    pipelines: pipelines?.length ? pipelines?.map(({ id: pipelineId }) => pipelineId) : [],
})
